module.exports = __webpack_public_path__ + "img/logo.7a7d8ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1